import sortBy from 'lodash/sortBy'

const byMinWidth = (a, b) =>
  b.minWidth - a.minWidth

const isHLS = (rendition) => {

  const src = rendition.src
  const suffix = src.substr(src.lastIndexOf('.'))
  return suffix === '.m3u8'

}

const withHLSFirst = (renditions) =>
  sortBy(renditions, val => {

    return isHLS(val) ? 0 : 1

  })

const toFileList = (rendition) => {

  return {
    file: rendition ? rendition.src : ''
  }

}

export const prioritiseMedia = (renditions) =>
  withHLSFirst(
    renditions
      .sort(byMinWidth)
  ).map(toFileList)

export const getMinWidth = (node) => {

  const media = node.getAttribute('media')
  if (media) {

    const width = media.match(/\d+/)

    return (width && width.length) ? parseInt(width[ 0 ]) : 0

  }
  return 0

}
